<template>
  <v-app>
    <v-app-bar app color="white" flat>
      <v-container>
        <v-row>
          <v-col class="ml-0 pl-0 mr-auto my-auto mt-6" cols="auto">
            <v-img width="225px" src="/img/RAFI_KIS_ME_Logo_Claim_pos.png"></v-img>
          </v-col>
          <v-col cols="auto" class="my-auto text-right pt-6">
            <v-spacer></v-spacer>
            <v-btn elevation="0" tile class="rafiButton petrol white--text" @click="backToKismeCom">
              {{ $t("app-bar.button") }}
              <v-icon dark right> mdi-arrow-right </v-icon></v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-main>
      <v-container>
        <v-row>
          <v-col class="mx-auto mt-12" cols="12" md="6">
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-footer app class="oceanblau white--text">
      <v-row class="text-center">
        <v-col class="rafiFooterLink">
          © RAFI Group · 2022 ·
          <a :href="$t('footer.impressumLink')" target="_blank">
            {{ $t("footer.impressum") }}
          </a>
          ·
          <a :href="$t('footer.dataProtectionLink')" target="_blank">
            {{ $t("footer.dataProtection") }}
          </a>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content: this.$t("meta.description"),
        },
        {
          name: "keywords",
          content: this.$t("meta.keywords"),
        },
      ],
    };
  },
  mounted() {
    this.$log.debug(`Environment is: ${process.env.NODE_ENV}`);
    this.$log.debug(`Base URL is: ${process.env.VUE_APP_BASE_URL}`);
    this.$log.debug(`Centersight URL is: ${process.env.VUE_APP_CENTERSIGHT}`);
  },
  methods: {
    backToKismeCom() {
      window.open(this.$t("backToKisme"), "_self"); //, "_blank"
    },
  },
};
</script>

<style lang="scss">
@import "./assets/styles/universLTStd.css";
@import "./assets/styles/mdi.min.css";

.rafiButton {
  font-size: 16px !important;
  text-transform: none !important;
}

.rafiFooterLink {
  a:link,
  a:visited,
  a:hover,
  a:active {
    background-color: rgba(255, 255, 255, 0);
    color: white;
    text-decoration: none;
  }
}
</style>
